import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './states/store';

import ShortLinkMainLayout from './components/ShortLinkMainLayout';
import App from './App';

// const AppRouter = () => (
//   <BrowserRouter>
//     <Route path='/:parameter1' render={(props) => <ShortLinkMainLayout {...props} />} />
//     <Route path='/' render={<ShortLinkMainLayout />} />
//   </BrowserRouter>
// );


ReactDOM.render(
  <React.StrictMode>
   <Provider store={store}>
    <Router>
      <Switch>
        <Route exact path='/' component={ShortLinkMainLayout} />
        <Route exact path='/home' component={ShortLinkMainLayout} />
        <Route exact path='/product' component={ShortLinkMainLayout} />
        <Route exact path='/about' component={ShortLinkMainLayout} />
        <Route exact path='/contact' component={ShortLinkMainLayout} />
        <Route path='/:parameter1' component={(props) => <ShortLinkMainLayout {...props} />} />
      </Switch>
    </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// ReactDOM.render(
//   <React.StrictMode>
//     <AppRouter></AppRouter>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
